import styled from 'styled-components'

export const TextContainer = styled.p`
    display: -webkit-box;

    line-height: 14px;
    font-size: 14px;
    -webkit-line-clamp: 6;
    height: calc(14px * 6);

    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: var(--font-bold);
    color: #fff;
    margin: 0;
`

export const PopupSVG = styled.g`
    pointer-events: none;

    rect {
        fill: var(--gray-900);
    }

    text {
        fill: var(--gray-0);
    }

    div {
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: min-content;
        flex-wrap: nowrap;
        white-space: nowrap;
        padding: 8px;
        max-width: 150px;
        height: 30px;
        background: var(--gray-900);
        color: var(--gray-0);

        &.THREAT {
            margin-left: auto;
        }

        &.CONSEQUENCE {
            margin-right: auto;
        }
    }
`

export const DeleteBottomContainer = styled.g`
    ${PopupSVG} {
        display: none;
    }

    :hover {
        ${PopupSVG} {
            display: unset;
        }
    }
`

export const ThreatConsequenceContainer = styled.g`
    ${DeleteBottomContainer} {
        display: none;
    }

    :hover {
        ${DeleteBottomContainer} {
            display: unset;
        }
    }
`
